<template>
  <div class="container py-5">
    <br>
    <div class="row">
      <div class="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center">
        <span class="fa-stack fa-2x mb-3">
          <i class="fal fa-circle fa-stack-2x text-danger"></i>
          <i class="fal fa-traffic-light-stop fa-stack-1x text-danger"></i>
        </span>
        <h1 class="h3">Ouch!</h1>
        <p class="lead grey px-5">We can't find the page you're looking for.</p>
        <hr>
        <p>It's probably our fault. We'll fix it swiftly 👊</p>
        <p>
          <small>
            <router-link class="blue" to="/">← Back to frontpage</router-link>
          </small>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    mounted() {
        this.$store.commit('meta/title', 'Page not found')
    },
}
</script>
